import React from 'react';
import '../template-file-css/document-file-template.css';


export const CMC_PsychEvals = ({
	itemsRef,
	showErrorFor,
}) => {

	return (
		<form id='CMC_PsychEvals' className='file-pdf-document'>
			<div className='file-template'>
			<p className='w-750'><h3>Cruse Medical Care Psychiatric Evaluation</h3></p>
                <table>
                    <tr>
                        <td className='w-500'>
                            <span className='eleHeader'>Client Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtCruseClientName' name='txtCruseClientName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtCruseClientDate' name='txtCruseClientDate' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Referral Source:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtReferralSource' name='txtReferralSource' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Accompanied By:</span>
                    <span className='small'>(Please check all that apply) the informant was:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAccompaniedBy_1' name='cbAccompaniedBy_1' className='add-only' value='Patient' /> Patient
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAccompaniedBy_2' name='cbAccompaniedBy_2' className='add-only' value='FamilyGuardian' /> {`Family/Guardian`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAccompaniedBy_3' name='cbAccompaniedBy_3' className='add-only' value='Friends' /> Friends
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAccompaniedBy_4' name='cbAccompaniedBy_4' className='add-only' value='HealthProfessional' /> Health Professional
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAccompaniedBy_5' name='cbAccompaniedBy_5' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtAccompaniedByOther' name='txtAccompaniedByOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insurance:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsurance_1' name='cbInsurance_1' className='add-only' value='Medicaid' /> Medicaid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsurance_2' name='cbInsurance_2' className='add-only' value='Amerigroup' /> Amerigroup
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsurance_3' name='cbInsurance_3' className='add-only' value='Cenpatico' /> Cenpatico
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInsurance_4' name='cbInsurance_4' className='add-only' value='HState Contract' /> State Contract
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3>Vitals :</h3></p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>WT</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>HT</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>BP</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>HR</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtVitalsWt' name='txtVitalsWt' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtVitalsHt' name='txtVitalsHt' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtVitalsBp' name='txtVitalsBp' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtVitalsHr' name='txtVitalsHr' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Current Score:`}</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>{`/Presenting Problem:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrentScoreOne' name='txtCurrentScoreOne' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtPresentingProblem' name='txtPresentingProblem' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    This is a <input type='text' id='txtThisIsYearsOld' name='txtThisIsYearsOld' className='add-only w-70 custom-add-only' /> years old (AA/Caucasian/Hispanic/Asian) male/female, accompanied by
                    (biological parent/ legal guardian/DCFCs <input type='text' id='txtCaucasianBiologicalParent' name='txtCaucasianBiologicalParent' className='add-only w-250 custom-add-only' />). Family was referred by <input type='text' id='txtLegalGuardianDfcOne' name='txtLegalGuardianDfcOne' className='add-only w-187 custom-add-only' />. Patient is currently presenting with <input type='text' id='txtPatientCurrentlyPresentingOne' name='txtPatientCurrentlyPresentingOne' className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    Current Stressors: <input type='text' id='txtCurrentStressors' name='txtCurrentStressors' className='add-only w-600 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Gender Identity:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGenderIdentity_1' name='cbGenderIdentity_1' className='add-only' value='Male' /> Male
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGenderIdentity_2' name='cbGenderIdentity_2' className='add-only' value='Female' /> Female
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGenderIdentity_3' name='cbGenderIdentity_3' className='add-only' value='NonBinary' /> Non-binary
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGenderIdentity_4' name='cbGenderIdentity_4' className='add-only' value='Transgender' /> Transgender
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGenderIdentity_5' name='cbGenderIdentity_5' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtGenderIdentityOther_1' name='txtGenderIdentityOther_1' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Clinical issues related to gender/transgender identification?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbClinicalIssueRelatedGender_Yes' name='rbClinicalIssueRelatedGender' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbClinicalIssueRelatedGender_No' name='rbClinicalIssueRelatedGender' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'> <h3>Symptoms:</h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Depressive Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptoms_1' name='cbDepressiveSymptoms_1' className='add-only' value='SI' /> SI
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptoms_2' name='cbDepressiveSymptoms_2' className='add-only' value='withInten' /> with inten
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptoms_3' name='cbDepressiveSymptoms_3' className='add-only' value='DepressedMood' /> depressed mood
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptoms_4' name='cbDepressiveSymptoms_4' className='add-only' value='ChangeInSleep' /> change in sleep
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsOne_1' name='cbDepressiveSymptomsOne_1' className='add-only' value='PoorEnergyFatigue' /> poor energy/fatigue
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsOne_2' name='cbDepressiveSymptomsOne_2' className='add-only' value='PoorConcentration' /> poor concentration
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsOne_3' name='cbDepressiveSymptomsOne_3' className='add-only' value='Irritability' /> irritability
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsOne_4' name='cbDepressiveSymptomsOne_4' className='add-only' value='Guilt' /> guilt
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsTwo_1' name='cbDepressiveSymptomsTwo_1' className='add-only' value='Hopelessness' /> hopelessness
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsTwo_2' name='cbDepressiveSymptomsTwo_2' className='add-only' value='Anhedonia' /> anhedonia
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsTwo_3' name='cbDepressiveSymptomsTwo_3' className='add-only' value='Explosiveness' /> explosiveness
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsTwo_4' name='cbDepressiveSymptomsTwo_4' className='add-only' value='ChangeInAppetite' /> change in appetite
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsThree_1' name='cbDepressiveSymptomsThree_1' className='add-only' value='CryingEpisodes' /> crying episodes
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsThree_2' name='cbDepressiveSymptomsThree_2' className='add-only' value='ThoughtsOfSuicide' /> thoughts of suicide
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsThree_3' name='cbDepressiveSymptomsThree_3' className='add-only' value='Rumination' /> rumination
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsThree_4' name='cbDepressiveSymptomsThree_4' className='add-only' value='Withdrawal' /> withdrawal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressiveSymptomsFour_2' name='cbDepressiveSymptomsFour_2' className='add-only' value='ThoughtsOfSuicide' /> thoughts of suicide
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDepressiveSymptomsFour_1' name='cbDepressiveSymptomsFour_1' className='add-only' value='NoEnjoymentInFavoriteActivities' /> no enjoyment in favorite activities
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtDepressiveSymptomsFourOther' name='txtDepressiveSymptomsFourOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Manic Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptoms_1' name='cbManicSymptoms_1' className='add-only' value='RacingThoughts' /> racing thoughts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptoms_2' name='cbManicSymptoms_2' className='add-only' value='DecreasedNeedForSleep' /> decreased need for sleep
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptoms_3' name='cbManicSymptoms_3' className='add-only' value='IncreasedGoalDirectedActivity' /> increased goal directed activity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptomsOne_1' name='cbManicSymptomsOne_1' className='add-only' value='SevereChangesInMood' /> severe changes in mood
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptomsOne_2' name='cbManicSymptomsOne_2' className='add-only' value='Euphoria' /> euphoria
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptomsOne_3' name='cbManicSymptomsOne_3' className='add-only' value='PressuredSpeech' /> pressured speech
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptomsTwo_1' name='cbManicSymptomsTwo_1' className='add-only' value='CryingEpisodes' /> crying episodes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptomsTwo_2' name='cbManicSymptomsTwo_2' className='add-only' value='UnrealisticHighsInSelfEsteem' /> unrealistic highs in self-esteem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptomsTwo_3' name='cbManicSymptomsTwo_3' className='add-only' value='IncreaseInTalking' /> increase in talking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbManicSymptomsThree_1' name='cbManicSymptomsThree_1' className='add-only' value='EasilyDistracted' /> easily distracted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtManicSymptomsOther' name='txtManicSymptomsOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ADHD Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptoms_1' name='cbAdhdSymptoms_1' className='add-only' value='LosingThings' /> losing things
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptoms_2' name='cbAdhdSymptoms_2' className='add-only' value='ForgettingThings' /> forgetting things
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptoms_3' name='cbAdhdSymptoms_3' className='add-only' value='Impulsivity' /> impulsivity
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptoms_4' name='cbAdhdSymptoms_4' className='add-only' value='ProblemsFinishingTasks' /> problems finishing tasks
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsOne_1' name='cbAdhdSymptomsOne_1' className='add-only' value='BlurtingOut' /> blurting out
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsOne_2' name='cbAdhdSymptomsOne_2' className='add-only' value='Interrupting' /> interrupting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsOne_3' name='cbAdhdSymptomsOne_3' className='add-only' value='Impatience' /> impatience
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsOne_4' name='cbAdhdSymptomsOne_4' className='add-only' value='Inattentiveness' /> inattentiveness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsThree_1' name='cbAdhdSymptomsThree_1' className='add-only' value='Distractibility' /> distractibility
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsThree_2' name='cbAdhdSymptomsThree_2' className='add-only' value='Hyperactivity' /> hyperactivity
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsThree_3' name='cbAdhdSymptomsThree_3' className='add-only' value='Fidgetiness' /> fidgetiness
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsThree_4' name='cbAdhdSymptomsThree_4' className='add-only' value='ProblemsSittingStill' /> problems sitting still
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsTwo_1' name='cbAdhdSymptomsTwo_1' className='add-only' value='ExcessiveTalking' /> excessive talking
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsTwo_2' name='cbAdhdSymptomsTwo_2' className='add-only' value='DayDreaming' /> daydreaming
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsTwo_3' name='cbAdhdSymptomsTwo_3' className='add-only' value='EasilyFrustrated' /> easily frustrated
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsTwo_4' name='cbAdhdSymptomsTwo_4' className='add-only' value='Boredom' /> boredom
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdhdSymptomsFour_4' name='cbAdhdSymptomsFour_4' className='add-only' value='PoorOrganizationSkills' /> poor organization skills
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAdhdSymptomsOther' name='txtAdhdSymptomsOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PTSD Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPtsdSymptoms_1' name='cbPtsdSymptoms_1' className='add-only' value='Nightmares' /> nightmares
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPtsdSymptoms_2' name='cbPtsdSymptoms_2' className='add-only' value='Flashbacks' /> flashbacks
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPtsdSymptoms_3' name='cbPtsdSymptoms_3' className='add-only' value='Disassociation' /> disassociation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPtsdSymptoms_4' name='cbPtsdSymptoms_4' className='add-only' value='Startle' /> startle
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPtsdSymptomsOne_1' name='cbPtsdSymptomsOne_1' className='add-only' value='Avoidance' /> avoidance
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPtsdSymptomsOne_2' name='cbPtsdSymptomsOne_2' className='add-only' value='IntrusiveThoughts' /> intrusive thoughts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPtsdSymptomsOther' name='txtPtsdSymptomsOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Violence:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbViolence_1' name='cbViolence_1' className='add-only' value='Fighting' /> fighting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbViolence_2' name='cbViolence_2' className='add-only' value='HI' /> HI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtViolenceOther' name='txtViolenceOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Psychosis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychosis_1' name='cbPsychosis_1' className='add-only' value='AH' /> AH
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychosis_2' name='cbPsychosis_2' className='add-only' value='VH' /> VH
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychosis_3' name='cbPsychosis_3' className='add-only' value='TH' /> TH
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPsychosis_4' name='cbPsychosis_4' className='add-only' value='OH' /> OH
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPsychosisOther' name='txtPsychosisOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Conduct Disorder Syndrome:</span>
                        </td>
                    </tr>
                    <tr>

                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndrome_2' name='cbConductDisorderSyndrome_2' className='add-only' value='AggressionToAnimals' /> aggression to animals
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndrome_3' name='cbConductDisorderSyndrome_3' className='add-only' value='DestructionOfProperty' /> destruction of property
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndrome_4' name='cbConductDisorderSyndrome_4' className='add-only' value='Deceitfulness' /> deceitfulness
                        </td>
                    </tr>
                    <tr>

                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndromeOne_2' name='cbConductDisorderSyndromeOne_2' className='add-only' value='Lying' /> lying
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndromeOne_3' name='cbConductDisorderSyndromeOne_3' className='add-only' value='Stealing' /> stealing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndromeOne_4' name='cbConductDisorderSyndromeOne_4' className='add-only' value='RunAway' /> run away
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndromeTwo_1' name='cbConductDisorderSyndromeTwo_1' className='add-only' value='AggressivenessToPeople' /> aggressiveness to People
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndromeTwo_2' name='cbConductDisorderSyndromeTwo_2' className='add-only' value='SeriousViolationsOfRules' /> serious violations of rules
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbConductDisorderSyndrome_1' name='cbConductDisorderSyndrome_1' className='add-only' value='FireSetting' /> fire setting
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorderSyndromeTwo_3' name='cbConductDisorderSyndromeTwo_3' className='add-only' value='LackOfRespectForAuthorityFigures' /> lack of respect for authority figures
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtConductDisorderSyndromeOther' name='txtConductDisorderSyndromeOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Oppositional Defiant Disorder (ODD) Symptoms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorder_2' name='cbOppositionslDefiantDisorder_2' className='add-only' value='TemperTantrums' />  temper tantrums
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorder_3' name='cbOppositionslDefiantDisorder_3' className='add-only' value='ExcessiveArguing' /> excessive arguing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorder_4' name='cbOppositionslDefiantDisorder_4' className='add-only' value='Anger' /> anger
                        </td>
                    </tr>
                    <tr>

                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorderOne_2' name='cbOppositionslDefiantDisorderOne_2' className='add-only' value='EasilyAnnoyedByOthers' /> easily annoyed by others
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorderOne_3' name='cbOppositionslDefiantDisorderOne_3' className='add-only' value='Defiance' /> defiance
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorderOne_4' name='cbOppositionslDefiantDisorderOne_4' className='add-only' value='BlamingOthersForMistakes' /> blaming others for mistakes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorderTwo_1' name='cbOppositionslDefiantDisorderTwo_1' className='add-only' value='SeeksRevenge' /> seeks revenge
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOppositionslDefiantDisorderTwo_2' name='cbOppositionslDefiantDisorderTwo_2' className='add-only' value='FrequentResentment' /> frequent resentment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtOppositionslDefiantDisorderOther' name='txtOppositionslDefiantDisorderOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Asperger's Disorder Symptoms:</span>
                        </td>
                    </tr>
                    <tr>

                        <td className='w-250'>
                            <input type='checkbox' id='cbAspergerDisorderSymptoms_1' name='cbAspergerDisorderSymptoms_1' className='add-only' value='RegulateSocialInteractions' />  regulate social interactions
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAspergerDisorderSymptoms_2' name='cbAspergerDisorderSymptoms_2' className='add-only' value='LackOfSpontaneity' /> lack of spontaneity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAspergerDisorderSymptoms_4' name='cbAspergerDisorderSymptoms_4' className='add-only' value='LikesToBeAlone' /> likes to be alone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAspergerDisorderSymptoms_3' name='cbAspergerDisorderSymptoms_3' className='add-only' value='LackOfSociaEmotionalReciprocation' /> lack of social/emotional reciprocation
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAspergerDisorderSymptoms_5' name='cbAspergerDisorderSymptoms_5' className='add-only' value='RepetitiveMotorMannerisms' /> repetitive motor mannerisms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAspergerDisorderSymptoms_6' name='cbAspergerDisorderSymptoms_6' className='add-only' value='LackOfPeerRelationshipsAppropriateToDevelopmentalLevel' /> lack of peer relationships appropriate to developmental level
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAspergerDisorderSymptomsOther' name='txtAspergerDisorderSymptomsOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Acute Stress Disorders:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_1' name='cbAcuteStressDisorders_1' className='add-only' value='Numbing' />  numbing
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_2' name='cbAcuteStressDisorders_2' className='add-only' value='Detachmen' /> detachmen
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_3' name='cbAcuteStressDisorders_3' className='add-only' value='ReExperiencingTraumaticEvent' /> re-experiencing traumatic event
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_4' name='cbAcuteStressDisorders_4' className='add-only' value='Anxiety' />  anxiety
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_5' name='cbAcuteStressDisorders_5' className='add-only' value='Irritability' /> irritability
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_6' name='cbAcuteStressDisorders_6' className='add-only' value='Depersonalization' /> depersonalization
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_7' name='cbAcuteStressDisorders_7' className='add-only' value='SleepProblems' />  sleep problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_8' name='cbAcuteStressDisorders_8' className='add-only' value='FlashBack' /> flash back
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_9' name='cbAcuteStressDisorders_9' className='add-only' value='PoorConcentration' /> poor concentration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_10' name='cbAcuteStressDisorders_10' className='add-only' value='AvoidanceOfAssociatedStimuli' />  avoidance of associated stimuli
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAcuteStressDisorders_11' name='cbAcuteStressDisorders_11' className='add-only' value='HyperVigilant' /> hyper-vigilant
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAcuteStressDisorders_12' name='cbAcuteStressDisorders_12' className='add-only' value='WitnessedTraumaticEventWithinWeeks' /> witnessed traumatic event within 4 weeks
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAcuteStressDisorders' name='txtAcuteStressDisorders' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Generalized Anxiety Disorder:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_1' name='cbGeneralizedAnxietyDisorder_1' className='add-only' value='ExcessiveUncontrollableWorry' />  excessive uncontrollable worry
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_2' name='cbGeneralizedAnxietyDisorder_2' className='add-only' value='Restlessness' /> restlessness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_3' name='cbGeneralizedAnxietyDisorder_3' className='add-only' value='PoorConcentration' /> poor concentration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_4' name='cbGeneralizedAnxietyDisorder_4' className='add-only' value='Irritation' />  irritation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_5' name='cbGeneralizedAnxietyDisorder_5' className='add-only' value='MuscleTension' /> muscle tension
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_6' name='cbGeneralizedAnxietyDisorder_6' className='add-only' value='SleepDisturbance' /> sleep disturbance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_7' name='cbGeneralizedAnxietyDisorder_7' className='add-only' value='HeartPalpitation' />  heart palpitation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralizedAnxietyDisorder_8' name='cbGeneralizedAnxietyDisorder_8' className='add-only' value='Fatigue' /> fatigue
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtGeneralizedAnxietyDisorder' name='txtGeneralizedAnxietyDisorder' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Intermittent Explosive Disorder:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIntermittentExplosiveDisorder_1' name='cbIntermittentExplosiveDisorder_1' className='add-only' value='PhysicalOutbursts' />  physical outbursts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIntermittentExplosiveDisorder_2' name='cbIntermittentExplosiveDisorder_2' className='add-only' value='DestructionProperties' /> destruction of properties
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIntermittentExplosiveDisorder_3' name='cbIntermittentExplosiveDisorder_3' className='add-only' value='PunchingHolesWall' /> punching holes on wall
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIntermittentExplosiveDisorder_4' name='cbIntermittentExplosiveDisorder_4' className='add-only' value='UnpredictedEpisodeOfExtremeAnger' />  unpredicted episode of extreme anger
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIntermittentExplosiveDisorder_5' name='cbIntermittentExplosiveDisorder_5' className='add-only' value='ThrowingObjectsBlamingOthersForProvokingThem' /> throwing objects, blaming others for provoking them
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtIntermittentExplosiveDisorder' name='txtIntermittentExplosiveDisorder' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Panic Disorder:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_1' name='cbPanicDisorder_1' className='add-only' value='Palpitation' /> palpitation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_2' name='cbPanicDisorder_2' className='add-only' value='RapidBreathing' /> rapid breathing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_3' name='cbPanicDisorder_3' className='add-only' value='BlurryVision' /> blurry vision
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_4' name='cbPanicDisorder_4' className='add-only' value='Dizziness' /> dizziness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_5' name='cbPanicDisorder_5' className='add-only' value='Fainting' /> fainting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_6' name='cbPanicDisorder_6' className='add-only' value='RacingThought' /> racing thought
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_7' name='cbPanicDisorder_7' className='add-only' value='Sweating' /> sweating
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_8' name='cbPanicDisorder_8' className='add-only' value='Trembling' /> trembling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_9' name='cbPanicDisorder_9' className='add-only' value='ChestPain' /> chest pain
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_10' name='cbPanicDisorder_10' className='add-only' value='FearOfDying' /> fear of dying
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_11' name='cbPanicDisorder_11' className='add-only' value='Paresthesia' /> paresthesia
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicDisorder_12' name='cbPanicDisorder_12' className='add-only' value='HotFlashes' /> hot flashes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPanicDisorder_13' name='cbPanicDisorder_13' className='add-only' value='SuddenAttackOfIntenseFearAnxiety' /> sudden attack of intense fear/anxiety
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPanicDisorder' name='txtPanicDisorder' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Anxiety Disorder NOS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAnxietyDisorderNos_1' name='cbAnxietyDisorderNos_1' className='add-only' value='DepressiveMood' /> depressive mood
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAnxietyDisorderNos_2' name='cbAnxietyDisorderNos_2' className='add-only' value='AnxietySymptoms' /> anxiety symptoms
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAnxietyDisorderNos_3' name='cbAnxietyDisorderNos_3' className='add-only' value='Stuttering' /> stuttering
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAnxietyDisorderNos_4' name='cbAnxietyDisorderNos_4' className='add-only' value='EatingDisorder' /> eating disorder
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAnxietyDisorderNos_5' name='cbAnxietyDisorderNos_5' className='add-only' value='DysmorphicDisorder' /> dysmorphic disorder
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAnxietyDisorderNos_6' name='cbAnxietyDisorderNos_6' className='add-only' value='StressorOrMedicalCondition' /> a stressor or medical condition
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAnxietyDisorderNos_7' name='cbAnxietyDisorderNos_7' className='add-only' value='SubstanceAbuseSymptoms' /> substance abuse symptoms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAnxietyDisorderNos' name='txtAnxietyDisorderNos' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Phobias:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_1' name='cbPhobias_1' className='add-only' value='ExtremeAnxiety' /> extreme anxiety
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_2' name='cbPhobias_2' className='add-only' value='AvoidanceBehavior' /> avoidance behavior
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_3' name='cbPhobias_3' className='add-only' value='Panicky' /> panicky
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_4' name='cbPhobias_4' className='add-only' value='Sweating' /> sweating
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_5' name='cbPhobias_5' className='add-only' value='RacingHeartBeat' /> racing heart beat
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_6' name='cbPhobias_6' className='add-only' value='DifficultyBreathing' /> difficulty breathing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_7' name='cbPhobias_7' className='add-only' value='FearOfCrowd' /> fear of crowd
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_8' name='cbPhobias_8' className='add-only' value='FearOfOpenSpace' /> fear of open space
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias_9' name='cbPhobias_9' className='add-only' value='FearOfEnclosedSpace' /> fear of enclosed space
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPhobias_10' name='cbPhobias_10' className='add-only' value='IrrationalFearOfObjectSituation' /> irrational fear of object/situation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPhobias_11' name='cbPhobias_11' className='add-only' value='FearOfObjects' /> fear of objects&nbsp;
                            <input type='text' id='txtPhobiasTextbox' name='txtPhobiasTextbox' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPhobiasOnetext' name='txtPhobiasOnetext' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Abuse:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_1' name='cbSubstanceAbuse_1' className='add-only' value='Marijuana' /> Marijuana
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_2' name='cbSubstanceAbuse_2' className='add-only' value='Etoh' /> ETOH
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_3' name='cbSubstanceAbuse_3' className='add-only' value='Stimulants' /> Stimulants
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_4' name='cbSubstanceAbuse_4' className='add-only' value='Mdma' /> MDMA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_5' name='cbSubstanceAbuse_5' className='add-only' value='Pcp' /> PCP
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_6' name='cbSubstanceAbuse_6' className='add-only' value='Ketamine' /> Ketamine
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_7' name='cbSubstanceAbuse_7' className='add-only' value='Heroin' /> Heroin
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_8' name='cbSubstanceAbuse_8' className='add-only' value='Cocaine' /> Cocaine
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_9' name='cbSubstanceAbuse_9' className='add-only' value='Lsd' /> LSD
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_10' name='cbSubstanceAbuse_10' className='add-only' value='Inhalant' /> Inhalant
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_11' name='cbSubstanceAbuse_11' className='add-only' value='Hashish' /> Hashish
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_12' name='cbSubstanceAbuse_12' className='add-only' value='Mushrooms' /> Mushrooms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSubstanceAbuse_14' name='cbSubstanceAbuse_14' className='add-only' value='Benzodiazepines' /> Benzodiazepines
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubstanceAbuse_13' name='cbSubstanceAbuse_13' className='add-only' value='CrystalMethamphetamine' /> Crystal Methamphetamine
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceAbuse_15' name='cbSubstanceAbuse_15' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtSubstanceAbuseOther' name='txtSubstanceAbuseOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtSubstanceAbuse_16' name='txtSubstanceAbuse_16' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Legal History:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_1' name='cbLegalHistory_1' className='add-only' value='UnrulyChild' /> unruly child
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_2' name='cbLegalHistory_2' className='add-only' value='Runaway' /> runaway
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_3' name='cbLegalHistory_3' className='add-only' value='DrugPossession' /> drug possession
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_4' name='cbLegalHistory_4' className='add-only' value='SellingDrugs' /> selling drugs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_5' name='cbLegalHistory_5' className='add-only' value='Battery' /> battery
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_6' name='cbLegalHistory_6' className='add-only' value='BurglaryTheft' /> burglary/theft
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_7' name='cbLegalHistory_7' className='add-only' value='Probation' /> probation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLegalHistory_8' name='cbLegalHistory_8' className='add-only' value='None' /> none
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLegalHistory_9' name='cbLegalHistory_9' className='add-only' value='ViolationOfProbation' /> violation of probation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtLegalHistory_10' name='txtLegalHistory_10' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='W-750'><h3>Previous Medical History</h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Patient reports/ denies history of asthma, seizure disorder, head injury concussion, and heart problems:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPatientReportDeniesHistoryAsthma' name='txtPatientReportDeniesHistoryAsthma' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>HX of surgeries</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbHxOfSurgeriesYes' name='rbHxOfSurgeries' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHxOfSurgeriesNo' name='rbHxOfSurgeries' className='add-only' value='No' /> No

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtHxOfSurgeriesText' name='txtHxOfSurgeriesText' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Patient reports/ denies HX of Allergy</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPatientReportDeniesHxAllergyYes' name='rbPatientReportDeniesHxAllergy' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPatientReportDeniesHxAllergyNo' name='rbPatientReportDeniesHxAllergy' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPatientReportDeniesHxAllergyText' name='txtPatientReportDeniesHxAllergyText' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='W-750'><span className='eleHeader'>Psychotropic Medication Review (Past & Present)</span></p>
                <p className='W-750'>
                    Patient was first/never evaluated at age of <input type='text' id='txtPsychotropicMedicationReviewText' name='txtPsychotropicMedicationReviewText' className='add-only w-375 custom-add-only' /> not currently treated with:
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> 1. Medication (best dose, frequency) </span></td>
                        <td className='w-250'> <span className='eleHeader'>Tolerability</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtMedicationText_1' name='txtMedicationText_1' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityGood_1' name='rbTolerability_1' className='add-only' value='Good' />  good
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityPoor_1' name='rbTolerability_1' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Response</span></td>
                        <td className='w-150'> <span className='eleHeader'>Started</span></td>
                        <td className='w-150'> <span className='eleHeader'>Last Taken</span></td>
                    </tr>
                    <tr>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse0_1' name='rbResponse_1' className='add-only' value='0' />  0%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse25_1' name='rbResponse_1' className='add-only' value='25' /> 25%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse50_1' name='rbResponse_1' className='add-only' value='50' />  50%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse75_1' name='rbResponse_1' className='add-only' value='75' /> 75%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse100_1' name='rbResponse_1' className='add-only' value='100' /> 100%
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtStarted_1' name='txtStarted_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastTaken_1' name='txtLastTaken_1' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'> 2. Medication (best dose, frequency) </span></td>
                        <td className='w-250'> <span className='eleHeader'>Tolerability</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtMedicationText_2' name='txtMedicationText_2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityGood_2' name='rbTolerability_2' className='add-only' value='Good' />  good
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityPoor_2' name='rbTolerability_2' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Response</span></td>
                        <td className='w-150'> <span className='eleHeader'>Started</span></td>
                        <td className='w-150'> <span className='eleHeader'>Last Taken</span></td>
                    </tr>
                    <tr>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse0_2' name='rbResponse_2' className='add-only' value='0' />  0%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse25_2' name='rbResponse_2' className='add-only' value='25' /> 25%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse50_2' name='rbResponse_2' className='add-only' value='50' />  50%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse75_2' name='rbResponse_2' className='add-only' value='75' /> 75%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse100_2' name='rbResponse_2' className='add-only' value='100' /> 100%
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtStarted_2' name='txtStarted_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastTaken_2' name='txtLastTaken_2' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'> 3. Medication (best dose, frequency) </span></td>
                        <td className='w-250'> <span className='eleHeader'>Tolerability</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtMedicationText_3' name='txtMedicationText_3' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityGood_3' name='rbTolerability_3' className='add-only' value='Good' />  good
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityPoor_3' name='rbTolerability_3' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Response</span></td>
                        <td className='w-150'> <span className='eleHeader'>Started</span></td>
                        <td className='w-150'> <span className='eleHeader'>Last Taken</span></td>
                    </tr>
                    <tr>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse0_3' name='rbResponse_3' className='add-only' value='0' />  0%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse25_3' name='rbResponse_3' className='add-only' value='25' /> 25%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse50_3' name='rbResponse_3' className='add-only' value='50' />  50%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse75_3' name='rbResponse_3' className='add-only' value='75' /> 75%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse100_3' name='rbResponse_3' className='add-only' value='100' /> 100%
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtStarted_3' name='txtStarted_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastTaken_3' name='txtLastTaken_3' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'> 4. Medication (best dose, frequency) </span></td>
                        <td className='w-250'> <span className='eleHeader'>Tolerability</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtMedicationText_4' name='txtMedicationText_4' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityGood_4' name='rbTolerability_4' className='add-only' value='Good' />  good
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityPoor_4' name='rbTolerability_4' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Response</span></td>
                        <td className='w-150'> <span className='eleHeader'>Started</span></td>
                        <td className='w-150'> <span className='eleHeader'>Last Taken</span></td>
                    </tr>
                    <tr>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse0_4' name='rbResponse_4' className='add-only' value='0' />  0%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse25_4' name='rbResponse_4' className='add-only' value='25' /> 25%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse50_4' name='rbResponse_4' className='add-only' value='50' />  50%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse75_4' name='rbResponse_4' className='add-only' value='75' /> 75%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse100_4' name='rbResponse_4' className='add-only' value='100' /> 100%
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtStarted_4' name='txtStarted_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastTaken_4' name='txtLastTaken_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'> 5. Medication (best dose, frequency) </span></td>
                        <td className='w-250'> <span className='eleHeader'>Tolerability</span></td>
                    </tr>

                    <tr>
                        <td className='w-500'>
                            <input type='text' id='txtMedicationText_5' name='txtMedicationText_5' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityGood_5' name='rbTolerability_5' className='add-only' value='Good' />  good
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbTolerabilityPoor_5' name='rbTolerability_5' className='add-only' value='Poor' /> Poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Response</span></td>
                        <td className='w-150'> <span className='eleHeader'>Started</span></td>
                        <td className='w-150'> <span className='eleHeader'>Last Taken</span></td>
                    </tr>
                    <tr>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse0_5' name='rbResponse_5' className='add-only' value='0' />  0%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse25_5' name='rbResponse_5' className='add-only' value='25' /> 25%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse50_5' name='rbResponse_5' className='add-only' value='50' />  50%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse75_5' name='rbResponse_5' className='add-only' value='75' /> 75%
                        </td>
                        <td className='w-90'>
                            <input type='radio' id='rbResponse100_5' name='rbResponse_5' className='add-only' value='100' /> 100%
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtStarted_5' name='txtStarted_5' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtLastTaken_5' name='txtLastTaken_5' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'> Patient reports/denies history of psychiatric hospitalization&nbsp; <input type='text' id='txtPatientReportsDenies' name='txtPatientReportsDenies' className='add-only w-350 custom-add-only' />
                </p>
                <p className='w-750'>Or past history of suicidal ideations &nbsp;<input type='text' id='txtPastHistorySuicidalIdeations' name='txtPastHistorySuicidalIdeations' className='add-only w-150 custom-add-only' />, attempts&nbsp; <input type='text' id='txtPastHistorySuicidalIdeationsOne' name='txtPastHistorySuicidalIdeationsOne' className='add-only w-150 custom-add-only' /> intent, or plan</p>
                <p className='w-750'> <input type='text' id='txtPastHistorySuicidalIdeationsTwo' name='txtPastHistorySuicidalIdeationsTwo' className='add-only' /></p>
                <p className='w-750'> Patient reports/denies history of homicidal ideations X &nbsp;<input type='text' id='txtPatientReportsHistoryHomicidalOne' name='txtPatientReportsHistoryHomicidalOne' className='add-only w-250 custom-add-only' />. Patient reports/ denies
                </p>
                <p className='w-750'>
                    history of counseling X&nbsp;<input type='text' id='txtHistoryCounselingOne' name='txtHistoryCounselingOne' className='add-only w-250 custom-add-only' />. Currently in/ discharged from treatment due
                </p>
                <p className='w-750'>
                    to <input type='text' id='txtHistoryCounselingTwo' name='txtHistoryCounselingTwo' className='add-only w-730 custom-add-only' />
                </p>
                <p className='w-750'> <h3>Family Psychiatric History:</h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Maternal Psychiatric History:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMaternalPsychiatricHistory' name='txtMaternalPsychiatricHistory' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Maternal Grandparents:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMaternalGrandparents' name='txtMaternalGrandparents' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Maternal Uncle/Aunt:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMaternalUncleAunt' name='txtMaternalUncleAunt' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Biological mother reports/ denies history of substance abuse/ dependence:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtBiologicalMotherReportsHistorySubstance' name='txtBiologicalMotherReportsHistorySubstance' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>She reports/ denies psychiatric history: P/O PTSD:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtSheReportsDeniesPsychiatricHistoryPtsd' name='txtSheReportsDeniesPsychiatricHistoryPtsd' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medication taken:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMedicationTaken' name='txtMedicationTaken' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mother reports/ denies history of psychiatric hospitalization, treatment or suicidal attempts:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMotherReportsDeniesHistoryPsychiatricAttemptes' name='txtMotherReportsDeniesHistoryPsychiatricAttemptes' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h3>Paternal Psychiatric History:</h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Paternal Grandparents:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPaternalGrandparents' name='txtPaternalGrandparents' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Paternal Uncle/Aunt:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtPaternalUncleAunt' name='txtPaternalUncleAunt' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Biological father reports/ denies history of substance abuse/ dependence:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtBiologicalFatherReportsDeniesHistory' name='txtBiologicalFatherReportsDeniesHistory' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>He reports/ denies psychiatric history:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtHeReportDeniesPsychiatricHistory' name='txtHeReportDeniesPsychiatricHistory' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medication taken:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtMedicationTaken' name='txtMedicationTaken' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Father reports/ denies history of psychiatric hospitalization, treatment or suicidal attempts:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtFatherReportsDeniesHistoryPsychiatric' name='txtFatherReportsDeniesHistoryPsychiatric' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>Social History:</span></p>
                <p className='w-750'>Patient was born&nbsp;<input type='text' id='txtPatientWasBorn' name='txtPatientWasBorn' className='add-only w-250 custom-add-only' />. # <input type='text' id='txtPatientWasBornOne' name='txtPatientWasBornOne' className='add-only w-250 custom-add-only' />&nbsp;of 1 children.</p>
                <p className='w-750'>Ages:&nbsp;<input type='text' id='txtPatientWasBornAge' name='txtPatientWasBornAge' className='add-only w-100 custom-add-only' />&nbsp;Patient was raised by:&nbsp;<input type='text' id='txtPatientWasRaisedBy' name='txtPatientWasRaisedBy' className='add-only w-375 custom-add-only' /></p>
                <p className='w-750'>Biological:&nbsp;<input type='text' id='txtBiologicalActively' name='txtBiologicalActively' className='add-only w-450 custom-add-only' />&nbsp;is/is not actively involved in case.
                </p>
                <p className='w-750'>
                    Patient currently lives with&nbsp;<input type='text' id='txtPatientCurrentlyLivesWith' name='txtPatientCurrentlyLivesWith' className='add-only w-250 custom-add-only' />&nbsp;Patient enjoys&nbsp;<input type='text' id='txtPatientEnjoys' name='txtPatientEnjoys' className='add-only w-200 custom-add-only' />
                </p>
                <p className='w-750'>
                    Patient is closest to&nbsp;<input type='text' id='txtPatientIsClosestTo' name='txtPatientIsClosestTo' className='add-only w-100 custom-add-only' />&nbsp;Patient report/ denies history of physical/sexual abuse.<input type='text' id='txtPatientPhysicalSexualAuseCurrentlyLivesWith' name='txtPatientPhysicalSexualAuseCurrentlyLivesWith' className='add-only w-150 custom-add-only' />
                </p>
                <p className='w-750'>
                    Patient reports/denies witnessing domestic abuse/violence&nbsp;<input type='text' id='txtPatientIsWitnessingDomestic' name='txtPatientIsWitnessingDomestic' className='add-only w-100 custom-add-only' />&nbsp;Patient is currently in &nbsp;<input type='text' id='txtPatientIsCurrentlyClosestTo' name='txtPatientIsCurrentlyClosestTo' className='add-only w-60 custom-add-only' />grade.
                </p>
                <p className='w-750'>{`Sp Ed/ Reg`}&nbsp;<input type='text' id='txtPatientIsSpEdRegClosestTo' name='txtPatientIsSpEdRegClosestTo' className='add-only w-100 custom-add-only' />&nbsp;Patient report/ denies history of repeating a grade.&nbsp;<input type='text' id='txtPatientDeniesHistoryRepeatingGrade' name='txtPatientDeniesHistoryRepeatingGrade' className='add-only w-200 custom-add-only' /></p>
                <p className='w-750'>
                    Patient report/ denies history of school expulsion or suspension
                    <textarea id='txtPatientReportSchoolExpulsionSuspension' name='txtPatientReportSchoolExpulsionSuspension' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='eleHeader'>Developmental History:</span>
                </p>
                <p className='w-750'>
                    <input type='text' id='txtDeniesReportHistoryDrugs' name='txtDeniesReportHistoryDrugs' className='add-only w-180 custom-add-only' />&nbsp;denies/reports history of illicit drugs use during pregnancy.&nbsp;<input type='text' id='txtWeeksOfPregnancy' name='txtWeeksOfPregnancy' className='add-only w-40 custom-add-only' />&nbsp;weeks of pregnancy
                </p>
                <p className='w-750'>C-Section due to<input type='text' id='txtNormalVaginalDelivery' name='txtNormalVaginalDelivery' className='add-only w-125 custom-add-only' />&nbsp;Normal /vaginal delivery Weight<input type='text' id='txtWeightAtBirth' name='txtWeightAtBirth' className='add-only w-50 custom-add-only' />&nbsp;Complication at birth<input type='text' id='txtNormlWeight' name='txtNormlWeight' className='add-only w-100 custom-add-only' /></p>
                <p className='w-750'>
                    Developmental milestones:
                    <textarea id='txtDevelopmentalMilestones' name='txtDevelopmentalMilestones' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    Patient was potty trained at age&nbsp;<input type='text' id='txtPatientWasPottyTrainedAtAge' name='txtPatientWasPottyTrainedAtAge' className='add-only w-50 custom-add-only' />&nbsp;Difficulty with transition&nbsp;<input type='text' id='txtDifficultyWithTransition' name='txtDifficultyWithTransition' className='add-only w-250 custom-add-only' /></p>
                <p className='w-750'>
                    Anticipatory posture&nbsp;<input type='text' id='txtAnticipatoryPosture' name='txtAnticipatoryPosture' className='add-only w-500 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Legal History:</span>
                </p>
                <p className='w-750'>
                    Patient reports/denies involvement with the police at the age of&nbsp;<input type='text' id='txtDevelopmentWithThePoliceAtAgeOf' name='txtDevelopmentWithThePoliceAtAgeOf' className='add-only w-50 custom-add-only' />&nbsp;due to&nbsp;<input type='text' id='txtDuetoPoliceAtAgeOf' name='txtDuetoPoliceAtAgeOf' className='add-only w-225 custom-add-only' /></p>
                <p className='w-750'>
                    HX of RYDC placement&nbsp;<input type='text' id='txtHxRydcPlacement' name='txtHxRydcPlacement' className='add-only w-300 custom-add-only' />&nbsp;Patient report/denies history of probation:
                </p>
                <p className='w-750'>
                    <input type='text' id='txtPatientProbationDoneOr' name='txtPatientProbationDoneOr' className='add-only w-750 custom-add-only' />
                </p>
                <p className='w-750'>
                    Patient reports/history of DEFACS involvement due to:
                    <textarea id='txtPatientDefacsInvolvementDueTo' name='txtPatientDefacsInvolvementDueTo' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Orientation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_6' name='cbOrientation_6' className='add-only' value='OrientedX' /> Oriented X4</td>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='Person' /> Person</td>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='Place' /> Place</td>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_3' name='cbOrientation_3' className='add-only' value='Time' /> Time</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_4' name='cbOrientation_4' className='add-only' value='Situation' /> Situation</td>
                        <td className='w-187'><input type='checkbox' id='cbOrientation_5' name='cbOrientation_5' className='add-only' value='DisorientedTo' /> Disoriented to</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='Appropriate' /> Appropriate</td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Disheveled' /> Disheveled</td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='PoorHygiene' /> Poor Hygiene</td>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_4' name='cbAppearance_4' className='add-only' value='Bizarre' /> Bizarre</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAppearance_5' name='cbAppearance_5' className='add-only' value='EyeContact' /> Eye contact</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbEyeContactDoneGood' name='rbEyeContactDone' className='add-only' value='Good' /> Good &nbsp;
                            <input type='radio' id='rbEyeContactDonePoor' name='rbEyeContactDone' className='add-only' value='Poor' /> Poor &nbsp;
                            <input type='radio' id='rbEyeContactDoneFair' name='rbEyeContactDone' className='add-only' value='Fair' /> fair
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Uncooperative' /> Uncooperative</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Aggressive' /> Aggressive</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Withdrawn' /> Withdrawn</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Intoxicated' /> Intoxicated</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='Normal' /> Normal</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='SlurredSpeech' /> Slurred Speech</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='RapidSpeech' /> Rapid Speech</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_9' name='cbSpeech_9' className='add-only' value='ImpairedMemory' /> Impaired Memory</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_10' name='cbSpeech_10' className='add-only' value='ImpairedJudgment' /> Impaired Judgment</td>
                        <td className='w-187'><input type='checkbox' id='cbSpeech_11' name='cbSpeech_11' className='add-only' value='Agitated' /> Agitated</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='IamOk' /> I'm Ok</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtMoodOther' name='txtMoodOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Normal' /> Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Labile' /> Labile
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Flat' /> Flat
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Angry' /> Angry
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_8' name='cbAffect_8' className='add-only' value='Fidgety' /> Fidgety
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_9' name='cbAffect_9' className='add-only' value='Depressed' /> Depressed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_6' name='cbAffect_6' className='add-only' value='Anxious' /> Anxious
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_7' name='cbAffect_7' className='add-only' value='Hyperactivity' /> Hyperactivity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='InappropriateToThought' /> Inappropriate to thought
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidal/Homicidal Risk</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_1' name='cbSuicidalHomicidalRisk_1' className='add-only' value='SuicidalOne' /> Suicidal
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_2' name='cbSuicidalHomicidalRisk_2' className='add-only' value='ThoughtOne' /> Thought
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_3' name='cbSuicidalHomicidalRisk_3' className='add-only' value='PlanOne' /> Plan
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_4' name='cbSuicidalHomicidalRisk_4' className='add-only' value='AttemptOne' /> Attempt
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_6' name='cbSuicidalHomicidalRisk_6' className='add-only' value='NoneOne' /> None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_7' name='cbSuicidalHomicidalRisk_7' className='add-only' value='Homicidal' /> Homicidal
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_8' name='cbSuicidalHomicidalRisk_8' className='add-only' value='Thought' /> Thought
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_9' name='cbSuicidalHomicidalRisk_9' className='add-only' value='Plan' /> Plan
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_10' name='cbSuicidalHomicidalRisk_10' className='add-only' value='Attempt' /> Attempt
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_11' name='cbSuicidalHomicidalRisk_11' className='add-only' value='None' /> None
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_1' name='cbThoughts_1' className='add-only' value='Rational' /> Rational
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_2' name='cbThoughts_2' className='add-only' value='Delusional' /> Delusional
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_3' name='cbThoughts_3' className='add-only' value='Tangential' /> Tangential
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_4' name='cbThoughts_4' className='add-only' value='Loose' /> Loose
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_5' name='cbThoughts_5' className='add-only' value='Blocking' /> Blocking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_6' name='cbThoughts_6' className='add-only' value='Circumstantial' /> Circumstantial
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_7' name='cbThoughts_7' className='add-only' value='Hallucinations' /> Hallucinations
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_8' name='cbThoughts_8' className='add-only' value='Audio' /> Audio
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughts_9' name='cbThoughts_9' className='add-only' value='Visual' /> Visual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='checkbox' id='cbThoughts_11' name='cbThoughts_11' className='add-only' value='Judgment' /> Judgment:&nbsp;&nbsp;
                            <input type='radio' id='rbJudgementPoor' name='rbJudgement' className='add-only' value='Poor' /> Poor &nbsp;
                            <input type='radio' id='rbJudgementAgeAppropriate' name='rbJudgement' className='add-only' value='AgeAppropriate' /> age appropriate &nbsp;
                            <input type='radio' id='rbJudgementGood' name='rbJudgement' className='add-only' value='good' /> good &nbsp;
                            <input type='radio' id='rbJudgementFair' name='rbJudgement' className='add-only' value='Fair' /> Fair
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbThoughts_12' name='cbThoughts_12' className='add-only' value='Insight' /> Insight:&nbsp;&nbsp;
                            <input type='radio' id='rbInsightGood' name='Insight' className='add-only' value='good' /> good &nbsp;
                            <input type='radio' id='rbInsightPoor' name='Insight' className='add-only' value='Poor' /> Poor &nbsp;
                            <input type='radio' id='rbInsightFair' name='Insight' className='add-only' value='Fair' /> Fair
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughts_10' name='cbThoughts_10' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtThoughtsOther' name='txtThoughtsOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Gender Identity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbGenderIdentityMale' name='rbGenderIdentity' className='add-only' value='Male' /> Male
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbGenderIdentityFemale' name='rbGenderIdentity' className='add-only' value='Female' /> Female
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbGenderIdentityNonBinary' name='rbGenderIdentity' className='add-only' value='NonBinary' /> Non-binary
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbGenderIdentityTransgender' name='rbGenderIdentity' className='add-only' value='Transgender' /> Transgender
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGenderIdentity_10' name='cbGenderIdentity_10' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtGenderIdentityOther' name='txtGenderIdentityOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> 3 Wishes:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            1.&nbsp;<input type='text' id='txtWishesOne' name='txtWishesOne' className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            2.&nbsp;<input type='text' id='txtWishesTwo' name='txtWishesTwo' className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            3.&nbsp;<input type='text' id='txtWishesThree' name='txtWishesThree' className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>DX:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Axis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAxis_1' name='txtAxis_1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Age onset</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`#Episodes`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>onset current:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgeOnset' name='txtAgeOnset' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtEpisodesAreFire' name='txtEpisodesAreFire' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtOnsetCurrent' name='txtOnsetCurrent' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other Axis I:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtOtherAxis' name='txtOtherAxis' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Axis II: _Deferred</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAxisDeferred' name='txtAxisDeferred' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Axis III: _None Acute; NKDA,`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAxisNoneAcuteNkda' name='txtAxisNoneAcuteNkda' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`(Check all current applicable general medical conditions):`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_1' name='cbGeneralMedicalConditionsApplicable_1' className='add-only' value='Hypertension' /> Hypertension
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_2' name='cbGeneralMedicalConditionsApplicable_2' className='add-only' value='HeartDisease' /> Heart Disease
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_3' name='cbGeneralMedicalConditionsApplicable_3' className='add-only' value='Chf' /> CHF
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_4' name='cbGeneralMedicalConditionsApplicable_4' className='add-only' value='Hiv' /> HIV
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_5' name='cbGeneralMedicalConditionsApplicable_5' className='add-only' value='Diabetes' /> Diabetes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_6' name='cbGeneralMedicalConditionsApplicable_6' className='add-only' value='Asthma' /> Asthma
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_7' name='cbGeneralMedicalConditionsApplicable_7' className='add-only' value='Copd' /> COPD
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_8' name='cbGeneralMedicalConditionsApplicable_8' className='add-only' value='Cancer' /> Cancer
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_9' name='cbGeneralMedicalConditionsApplicable_9' className='add-only' value='Liver' /> Liver
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_10' name='cbGeneralMedicalConditionsApplicable_10' className='add-only' value='Hypothyroidism' /> Hypothyroidism
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_11' name='cbGeneralMedicalConditionsApplicable_11' className='add-only' value='Seizures' /> Seizures
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_12' name='cbGeneralMedicalConditionsApplicable_12' className='add-only' value='HeadInjury' /> Head Injury
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_13' name='cbGeneralMedicalConditionsApplicable_13' className='add-only' value='Stroke' /> Stroke
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_14' name='cbGeneralMedicalConditionsApplicable_14' className='add-only' value='Renal' /> Renal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_15' name='cbGeneralMedicalConditionsApplicable_15' className='add-only' value='ArthritisRheumaticDisorder' /> Arthritis/Rheumatic disorder
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_16' name='cbGeneralMedicalConditionsApplicable_16' className='add-only' value='Other' /> Other Cardiac
                            <input type='text' id='txtGenderMedicalConditionsApplicableOther_1' name='txtGenderMedicalConditionsApplicableOther_1' className='add-only w-500 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_17' name='cbGeneralMedicalConditionsApplicable_17' className='add-only' value='Other' /> Other Neurological
                            <input type='text' id='txtGenderMedicalConditionsApplicableOther_2' name='txtGenderMedicalConditionsApplicableOther_2' className='add-only w-500 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGeneralMedicalConditionsApplicable_18' name='cbGeneralMedicalConditionsApplicable_18' className='add-only' value='Other' /> Other Endocrine
                            <input type='text' id='txtGenderMedicalConditionsApplicableOther_3' name='txtGenderMedicalConditionsApplicableOther_3' className='add-only w-500 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Additional information (as well as pertinent non- behavioral health needs):`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtPatientDefacsInvolvementDueTo' name='txtPatientDefacsInvolvementDueTo' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Axis IV: (social stressors)`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='text' id='txtAxisIvSocial' name='txtAxisIvSocial' className='add-only w-50 custom-add-only' />&nbsp;&nbsp;l&nbsp;&nbsp;<input type='text' id='txtAxisIvSocialOne' name='txtAxisIvSocialOne' className='add-only w-650 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Axis V: (GAF)`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAxisVgaf' name='txtAxisVgaf' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Plan:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtPlanOne' name='txtPlanOne' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Treatment Plan:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            1.&nbsp;<input type='text' id='txtTreatmentPlanOne' name='txtTreatmentPlanOne' className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            2.&nbsp;<input type='text' id='txtTreatmentPlanTwo' name='txtTreatmentPlanTwo' className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            3.&nbsp;<input type='text' id='txtTreatmentPlanThree' name='txtTreatmentPlanThree' className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            4.&nbsp;<input type='text' id='txtTreatmentPlanFour' name='txtTreatmentPlanFour' className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>&nbsp;</td>
                        <td className='w-600'>
                            <b>{`2a. EKG:`}</b>&nbsp;
                            <input type='radio' id='rbAekgOneOnly_Yes' name='rbAekgOneOnly' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAekgOneOnly_No' name='rbAekgOneOnly' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><span className='eleHeader'>5.</span></td>
                        <td className='w-730'>
                            <span className='eleHeader'>{`Medication Indication/ Rational for use:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type='text' id='txtTreatmentPlanFive' name='txtTreatmentPlanFive' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'><span className='eleHeader'>6.</span></td>
                        <td className='w-730'>
                            <span className='eleHeader'>CAP forms:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>&nbsp;</td>
                        <td className='w-730'>
                            <input type='radio' id='rbCapForms_Yes' name='rbCapForms' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCapForms_No' name='rbCapForms' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-280'>
                            7.&nbsp;<input type='checkbox' id='cbTreatmentPlanOne_1' name='cbTreatmentPlanOne_1' className='add-only' value='ComprehensiveMetabolicPanel' /> Comprehensive Metabolic panel
                        </td>
                        <td className='w-220'>
                            <input type='checkbox' id='cbTreatmentPlanOne_2' name='cbTreatmentPlanOne_2' className='add-only' value='ThyroidStudies' /> Thyroid studies
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTreatmentPlanOne_3' name='cbTreatmentPlanOne_3' className='add-only' value='Cbcwdiff' /> CBC w/diff
                        </td>
                    </tr>
                    <tr>
                        <td className='w-10'>&nbsp;</td>
                        <td className='w-270'>
                            <input type='checkbox' id='cbTreatmentPlanOne_4' name='cbTreatmentPlanOne_4' className='add-only' value='Cholesterol' /> Cholesterol
                        </td>
                        <td className='w-220'>
                            <input type='checkbox' id='cbTreatmentPlanOne_5' name='cbTreatmentPlanOne_5' className='add-only' value='Fbs' /> FBS
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTreatmentPlanOne_6' name='cbTreatmentPlanOne_6' className='add-only' value='DepEdcoteLevel' /> Dep edcote level
                        </td>
                    </tr>
                    <tr>
                        <td className='w-10'>&nbsp;</td>
                        <td className='w-240'>
                            <input type='checkbox' id='cbTreatmentPlanOne_7' name='cbTreatmentPlanOne_7' className='add-only' value='LithiumLevel' /> lithium level
                        </td>
                    </tr>
                    <tr>
                        <td className='w-10'>&nbsp;</td>
                        <td className='w-740'>
                            <input type='checkbox' id='cbTreatmentPlanOne_8' name='cbTreatmentPlanOne_8' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtTreatmentPlanOther' name='txtTreatmentPlanOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Informed Consent:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Lab Reviewed:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>AIMS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbinformedConsent_Yes' name='rbinformedConsent' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbinformedConsent_No' name='rbinformedConsent' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbLabReviewed_Yes' name='rbLabReviewed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLabReviewed_No' name='rbLabReviewed' className='add-only' value='No' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAimsOne_Yes' name='rbAimsOne' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAimsOne_No' name='rbAimsOne' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Client verbalizes/understands to call 911, walk into the ER, or call the crisis line if symptoms worsen or if the client feels SI/HI.`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbClientVerbalizesUnderstands_Yes' name='rbClientVerbalizesUnderstands' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbClientVerbalizesUnderstands_No' name='rbClientVerbalizesUnderstands' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Physicians Signature:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Dr. Shelly Yusuff M.D., P.C.</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Service:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Time in:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Time out:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='date' id='txtDateOfService' name='txtDateOfService' className='add-only' />
                        </td>
                        <td className='w-250'><input type='time' id='txtTimeIn' name='txtTimeIn' className='add-only' />
                        </td>
                        <td className='w-250'><input type='time' id='txtTimeOut' name='txtTimeOut' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`I have discussed with my physician the fact that he/she is recommending that I take:`}</span>
                            <span className='small'>{` (circle all that apply):`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_1' name='cbDiscussedWithPhysicians_1' className='add-only' value='Allegra' /> Allegra
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_2' name='cbDiscussedWithPhysicians_2' className='add-only' value='Cylert' /> Cylert
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_3' name='cbDiscussedWithPhysicians_3' className='add-only' value='Imitrex' /> Imitrex
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_4' name='cbDiscussedWithPhysicians_4' className='add-only' value='Provigil' /> Provigil
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_5' name='cbDiscussedWithPhysicians_5' className='add-only' value='Synthroid' /> Synthroid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_6' name='cbDiscussedWithPhysicians_6' className='add-only' value='ZyprexaZydis' /> Zyprexa Zydis
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_7' name='cbDiscussedWithPhysicians_7' className='add-only' value='Ambien' /> Ambien
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_8' name='cbDiscussedWithPhysicians_8' className='add-only' value='Depakene' /> Depakene
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_9' name='cbDiscussedWithPhysicians_9' className='add-only' value='Klonopin' /> Klonopin
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_10' name='cbDiscussedWithPhysicians_10' className='add-only' value='Prozac' /> Prozac
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_11' name='cbDiscussedWithPhysicians_11' className='add-only' value='Tegretol' /> Tegretol
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_12' name='cbDiscussedWithPhysicians_12' className='add-only' value='Vyvanse' /> Vyvanse
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_13' name='cbDiscussedWithPhysicians_13' className='add-only' value='Antabuse' /> Antabuse
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_14' name='cbDiscussedWithPhysicians_14' className='add-only' value='DepakoteER' /> Depakote ER
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_15' name='cbDiscussedWithPhysicians_15' className='add-only' value='Lamietal' /> Lamietal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_16' name='cbDiscussedWithPhysicians_16' className='add-only' value='Remeron' /> Remeron
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_17' name='cbDiscussedWithPhysicians_17' className='add-only' value='Aricept' /> Aricept
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_18' name='cbDiscussedWithPhysicians_18' className='add-only' value='DepakoteLe' /> Depakote Le
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_19' name='cbDiscussedWithPhysicians_19' className='add-only' value='Lexapro' /> Lexapro
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_20' name='cbDiscussedWithPhysicians_20' className='add-only' value='RemeronSolTab' /> Remeron Sol Tab
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_21' name='cbDiscussedWithPhysicians_21' className='add-only' value='Tenex' /> Tenex
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_22' name='cbDiscussedWithPhysicians_22' className='add-only' value='Artane' /> Artane
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_23' name='cbDiscussedWithPhysicians_23' className='add-only' value='Desyrel' /> Desyrel
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_24' name='cbDiscussedWithPhysicians_24' className='add-only' value='Librium' /> Librium
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_25' name='cbDiscussedWithPhysicians_25' className='add-only' value='Reminyl' /> Reminyl
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_26' name='cbDiscussedWithPhysicians_26' className='add-only' value='Topamax' /> Topamax
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_27' name='cbDiscussedWithPhysicians_27' className='add-only' value='Atarez' /> Atarez
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_28' name='cbDiscussedWithPhysicians_28' className='add-only' value='Dexedrine' /> Dexedrine
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_29' name='cbDiscussedWithPhysicians_29' className='add-only' value='LithiumCarbonate' /> Lithium Carbonate
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_30' name='cbDiscussedWithPhysicians_30' className='add-only' value='Restoril' /> Restoril
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_31' name='cbDiscussedWithPhysicians_31' className='add-only' value='Trazodone' /> Trazodone
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_32' name='cbDiscussedWithPhysicians_32' className='add-only' value='Ativan' /> Ativan
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_33' name='cbDiscussedWithPhysicians_33' className='add-only' value='Dexotrosat' /> Dexotrosat
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_34' name='cbDiscussedWithPhysicians_34' className='add-only' value='Luvox' /> Luvox
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_35' name='cbDiscussedWithPhysicians_35' className='add-only' value='ReVia' /> ReVia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_36' name='cbDiscussedWithPhysicians_36' className='add-only' value='Trileptal' /> Trileptal
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_37' name='cbDiscussedWithPhysicians_37' className='add-only' value='Axert' /> Axert
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_38' name='cbDiscussedWithPhysicians_38' className='add-only' value='Effexor' /> Effexor
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_39' name='cbDiscussedWithPhysicians_39' className='add-only' value='Melaril' /> Melaril
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_40' name='cbDiscussedWithPhysicians_40' className='add-only' value='Risperdal' /> Risperdal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_41' name='cbDiscussedWithPhysicians_41' className='add-only' value='Ultram' /> Ultram
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_42' name='cbDiscussedWithPhysicians_42' className='add-only' value='Benadryl' /> Benadryl
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_43' name='cbDiscussedWithPhysicians_43' className='add-only' value='EffexorXR' /> Effexor XR
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_44' name='cbDiscussedWithPhysicians_44' className='add-only' value='MetadateCD' /> Metadate CD
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_45' name='cbDiscussedWithPhysicians_45' className='add-only' value='Ritalin' /> Ritalin
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_46' name='cbDiscussedWithPhysicians_46' className='add-only' value='Valium' /> Valium
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_47' name='cbDiscussedWithPhysicians_47' className='add-only' value='Bextra' /> Bextra
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_48' name='cbDiscussedWithPhysicians_48' className='add-only' value='Elavil' /> Elavil
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_49' name='cbDiscussedWithPhysicians_49' className='add-only' value='Methylin' /> Methylin
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_50' name='cbDiscussedWithPhysicians_50' className='add-only' value='RitalinLA' /> Ritalin LA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_51' name='cbDiscussedWithPhysicians_51' className='add-only' value='Viagra' /> Viagra
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_52' name='cbDiscussedWithPhysicians_52' className='add-only' value='Buspar' /> Buspar
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_53' name='cbDiscussedWithPhysicians_53' className='add-only' value='Eskalith' /> Eskalith
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_54' name='cbDiscussedWithPhysicians_54' className='add-only' value='Navane' /> Navane
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_55' name='cbDiscussedWithPhysicians_55' className='add-only' value='RitalinSR' /> Ritalin SR
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_56' name='cbDiscussedWithPhysicians_56' className='add-only' value='Vistaril' /> Vistaril
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_57' name='cbDiscussedWithPhysicians_57' className='add-only' value='Carbatrol' /> Carbatrol
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_58' name='cbDiscussedWithPhysicians_58' className='add-only' value='Exelon' /> Exelon
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_59' name='cbDiscussedWithPhysicians_59' className='add-only' value='Neurontin' /> Neurontin
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_60' name='cbDiscussedWithPhysicians_60' className='add-only' value='Sarafem' /> Sarafem
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_61' name='cbDiscussedWithPhysicians_61' className='add-only' value='Wellbutrin' /> Wellbutrin
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_62' name='cbDiscussedWithPhysicians_62' className='add-only' value='CeIebrex' /> CeIebrex
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_63' name='cbDiscussedWithPhysicians_63' className='add-only' value='Focalin' /> Focalin
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_64' name='cbDiscussedWithPhysicians_64' className='add-only' value='Nortripyline' /> Nortripyline
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_65' name='cbDiscussedWithPhysicians_65' className='add-only' value='Scrax' /> Scrax
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_66' name='cbDiscussedWithPhysicians_66' className='add-only' value='WellbutrinSR' /> Wellbutrin SR
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_67' name='cbDiscussedWithPhysicians_67' className='add-only' value='Celexa' /> Celexa
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_68' name='cbDiscussedWithPhysicians_68' className='add-only' value='FocalinXR' /> Focalin XR
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_69' name='cbDiscussedWithPhysicians_69' className='add-only' value='Pamelor' /> Pamelor
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_70' name='cbDiscussedWithPhysicians_70' className='add-only' value='Seroquel' /> Seroquel
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_71' name='cbDiscussedWithPhysicians_71' className='add-only' value='Xanax' /> Xanax
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_72' name='cbDiscussedWithPhysicians_72' className='add-only' value='ChloralHyd' /> Chloral Hyd
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_73' name='cbDiscussedWithPhysicians_73' className='add-only' value='Fluoxetine' /> Fluoxetine
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_74' name='cbDiscussedWithPhysicians_74' className='add-only' value='Paxil' /> Paxil
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_75' name='cbDiscussedWithPhysicians_75' className='add-only' value='SeroquelXR' /> Seroquel XR
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_76' name='cbDiscussedWithPhysicians_76' className='add-only' value='Zantac' /> Zantac
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_77' name='cbDiscussedWithPhysicians_77' className='add-only' value='Clonidine' /> Clonidine
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_78' name='cbDiscussedWithPhysicians_78' className='add-only' value='Gabitril' /> Gabitril
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_79' name='cbDiscussedWithPhysicians_79' className='add-only' value='PaxilCR' /> Paxil CR
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_80' name='cbDiscussedWithPhysicians_80' className='add-only' value='Serzone' /> Serzone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_81' name='cbDiscussedWithPhysicians_81' className='add-only' value='Zoloft' /> Zoloft
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDiscussedWithPhysicians_82' name='cbDiscussedWithPhysicians_82' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtDiscussedWithPhysiciansOther' name='txtDiscussedWithPhysiciansOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`For my treatment, I understand that in the physician's opinion, this is the most appropriate course of treatment to improve a nd/or prevent the relapse of my symptoms`}
                </p>
                <p className='w-750'>
                    {`I have discussed and fully understand both the potential benefits and risks of the medications prescribed for me. I understand that a possible risk of the medications prescribed may potentially include long term and for permanent side effects. I understand that I will be routinely examined to determine if I have developed any negative side effects.`}
                </p>
                <p className='w-750'>
                    {`I accept responsibility to keep my physician fully informed of any difficulties that I might be experiencing during these assessments. I understand that side effects from the medication may at times be hidden by these medications and without periodic drug-free trials, may not be observed during my examinations.`}
                </p>
                <p className='w-750'>
                    {`I give consent to begin/continue the medication (so described to me). I am fully aware of risks and benefits associated with that treatment and have been given the opportunity to ask any and all questions regarding my care. I understand that at any time I may change my mind and withdraw my consent.`}
                </p>
                <p className='w-750'>
                    {`I acknowledge that possibility of cardiac side effects were explained by the doctor and my signature below acknowledges my understanding of this information.`}
                </p>
                <p className='w-750'>
                    {`Note: The FDA has recently reported that all antidepressants might be contributory to suicidal ideation`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Patient/Parent/Guardian Signature  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    {`As the attending physician, it is in my opinion that this patient is capable of giving informed consent. Additionally my designee or I have fully reviewed with the patient the medications described above and am satisfied that the patient understands the issues as discussed.`}
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Physician Signature  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Lab Request Form</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Date</span>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'>Patient Name:</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Birth:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='date' id='txtDateOneDone' name='txtDateOneDone' className='add-only' />
                        </td>
                        <td className='w-450'><input type='text' id='txtPateintName' name='txtPateintName' className='add-only' />
                        </td>
                        <td className='w-150'><input type='date' id='txtDateOfBirthOne' name='txtDateOfBirthOne' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Diagnostic Code(s):`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Medical Insurance:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`ID#:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDiagnosticCode' name='txtDiagnosticCode' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMedicalInsurance' name='txtMedicalInsurance' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtIdOneDone' name='txtIdOneDone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><b>This Office WILL NOT pay for the requested labs</b></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Chemistry/Hematology`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChemistryHematology_1' name='cbChemistryHematology_1' className='add-only' value='SerumLithium' /> {`Serum Lithium (007708@80178)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChemistryHematology_2' name='cbChemistryHematology_2' className='add-only' value='SerumCarbamazepine' /> {`Serum Carbamazepine (007419@80156)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbChemistryHematology_3' name='cbChemistryHematology_3' className='add-only' value='SerumValproicAcid' /> {`Serum Valproic Acid (007260@80164)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbChemistryHematology_4' name='cbChemistryHematology_4' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtChemistryHematologyOther' name='txtChemistryHematologyOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Fasting</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbFasting_1' name='cbFasting_1' className='add-only' value='CompleteBloodCountDifferential' /> {`Complete Blood Count w/differential w/pit (005009@85025)`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFasting_2' name='cbFasting_2' className='add-only' value='Cholesterol' /> {`Cholesterol (001065@82465)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFasting_3' name='cbFasting_3' className='add-only' value='ComprehensiveMetabolicPanel' /> {`Comprehensive Metabolic Panel (322000@80053)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFasting_3' name='cbFasting_3' className='add-only' value='ThyroidPanelTriiodothyronine' /> {`Thyroid Panel-TSH, Triiodothyronine (T3), and T4 (004259@84443, 002188@84480, and 001149@84436)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFasting_4' name='cbFasting_4' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtFastingOther' name='txtFastingOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>EKG</span>
                </p>
                <p className='w-750'>
                    {`Reason for EKD: Need medical clearance letter for stimulant medications. (Need recent interpreted summary of echocardiogram data if available).`}
                </p>
                <p className='w-750'>
                    Hx and current medications:
                </p>
                <p className='w-750'>
                    <input type='text' id='txtCurrentMedicationsOne' name='txtCurrentMedicationsOne' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>EEG</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEegOne_1' name='cbEegOne_1' className='add-only' value='Eeg' /> EEG
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEegOne_2' name='cbEegOne_2' className='add-only' value='SleepDeprived' /> Sleep Deprived
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEegOne_3' name='cbEegOne_3' className='add-only' value='NasopharyngealLeads' /> Nasopharyngeal Leads
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEegOne_4' name='cbEegOne_4' className='add-only' value='SleepStudy' />  Sleep Study
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            {`Reason for EEG: Need to rule out an abnormal EEG. (i.e. Seizure disorder).`}
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    History:
                </p>
                <p className='w-750'>
                    <input type='text' id='txtHistoryOne' name='txtHistoryOne' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Neuroimaging</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeuroimagingOne_1' name='cbNeuroimagingOne_1' className='add-only' value='CTHead' /> CT Head
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeuroimagingOne_2' name='cbNeuroimagingOne_2' className='add-only' value='Mri' /> MRI
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeuroimagingOne_3' name='cbNeuroimagingOne_3' className='add-only' value='Contrast' /> Contrast
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Study:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtReasonForStudy' name='txtReasonForStudy' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>History:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtHistory' name='txtHistory' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> {`Physician Signature:`}</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>
                                PLEASE FAX RESULTS TO 678-377-8014
                            </b>
                        </td>
                    </tr>
                </table>
			</div>
		</form>

	)
}  
